import * as RadixVisuallyHidden from '@radix-ui/react-visually-hidden';

export const VisuallyHidden = RadixVisuallyHidden.Root;
